module.exports = {
	"nav": {
		"home": "HOME",
		"about": "ABOUT",
		"food": "FOOD",
		"projects": "PROJECTS+EVENTS",
		"takeaway": "HOME EDITION",
		"whatwedo": "WHAT WE DO",
		"gallery": "GALLERY",
		"contact": "CONTACT",
		"logo": "logo.png"
	},
	"home": {
		"title": "CREATIVE<br/>FOOD<br/>INDULGENCE",
		"subtitle": "A LONDON-BASED CATERING AND DESIGN COLLECTIVE <br class='break-large' />PRODUCING BESPOKE FOOD, EXPERIENCES AND CONTENT FOR A WIDE <br class='break-large' />SPECTRUM OF CLIENTS LOOKING FOR SOMETHING DIFFERENT",
		"lockup": {
			"lockup_1": "home_lockup_portrait_01.jpg",
			"lockup_2": "home_lockup_landscape_01.jpg",
			"lockup_3": "home_lockup_square_01.jpg",
			"text_img": "masthead_text.png"
		},
		"about": "ABOUT",
		"about_body": [
			"Room Service launched with the ‘Club Sandwich Luxe’ pop-up and Shoreditch kitchen residency in 2015. Although the food and offering has evolved, the <i>indulgent, shameless excess</i> those towering club sandwiches represent set the template that runs through everything we do."
		],
		"food": "FOOD",
		"food_body": [
			"Championing food that is social and seasonal, with a laidback indulgence."
		],
		"food_image": "food_home_landscape_01.jpg",
		"projects": "PROJECTS<br/>+<br/>EVENTS",
		"projects_body": [
			"Creative projects, unique events, curation and consultancy with food always at the heart."
		],
		"projects_image": "projects_home_landscape_01.jpg",
		"canteen": "QUARANTINE CANTEEN",
		"canteen_body": [
			"Some canteen copy to go in here."
		],
		"canteen_image": "food_home_landscape_01.jpg",
		"contact_button": "GET IN TOUCH",
		"link_button": "READ MORE",
		"loadArray": [
			"home/home_lockup_portrait_01.jpg",
			"home/home_lockup_landscape_01.jpg",
			"home/home_lockup_square_01.jpg",
			"home/masthead_text.png",
			"home/food_home_landscape_01.jpg",
			"home/projects_home_landscape_01.jpg"
		]
	},
	"contact": {
		"contact_button": "GET IN TOUCH",
		"instagram_icon_dark": "instagram_logo.svg",
		"instagram_icon_light": "instagram_logo_pink.svg",
		"instagram_link": "https://www.instagram.com/getroomservice/",
		"instagram_text": "@getroomservice ",
		"email_icon_dark": "email_logo.svg",
		"email_icon_light": "email_logo_pink.svg",
		"email_link": "mailto:hello@getroomservice.co?subject=Hello",
		"email_text": "hello@getroomservice.co",
		"phone_icon_dark": "phone_logo.svg",
		"phone_icon_light": "phone_logo_pink.svg",
		"phone_link": "tel:07980915489",
		"phone_text": "07980 915489",
		"pink_instagram_icon": "instagram_logo_pink.svg",
		"pink_email_icon": "email_logo_pink.svg"
	},
	"food": {
		"title": "FOOD",
		"subtitle": "CHAMPIONING FOOD THAT IS SOCIAL AND SEASONAL, WITH A LAIDBACK INDULGENCE, WE GET KICKS FROM CONTEMPORARY FINE DINING TO FAST FOOD, STREET FOOD TO BRITISH CLASSICS, THE GOOD LIFE TO THE DOWNRIGHT DIRTY",
		"body": [
			"Sourcing the best possible ingredients from quality, unique suppliers so we can consciously deliver shameless excess and indulgence on plates, sticks, bowls, boxes and platters.",
			"A custom approach to every feast, party or project. This means no generic menus to have to choose from, no 'one size fits all' attitude. We'll come back with ideas to fit any brief and budget, and are happy to inspire clients who don't yet have a starting point.",
			"Street food for 500 in a field, banquets for 150 in a warehouse, feasts for 50 on a private island or canapés to add proper flavour to a launch event. Whatever the event and whatever the size, we make food to make your party."
		],
		"folder": "food",
		"lockup": {
			"lockup_1": "food_lockup_portrait_01.jpg",
			"lockup_2": "food_lockup_landscape_01.jpg",
			"lockup_3": "food_lockup_square_01.jpg",
			"text_img": "masthead_text_food.png"
		},
		"loadArray": [
			"food/food_lockup_portrait_01.jpg",
			"food/food_lockup_landscape_01.jpg",
			"food/food_lockup_square_01.jpg",
			"food/masthead_text_food.png"
		]
	},
	"projects": {
		"title": "PROJECTS<br/>+<br/>EVENTS",
		"subtitle": "Creative projects, unique events, curation <br class='break-large' />and consultancy with food always at the heart",
		"body": [
			"As well as chefs, we have a network of designers, art directors, food stylists and event producers. This means we deliver way more than just food on a plate and takes the stress out of our client's hands.",
			"We've brought underground 80s New York to Osea Island, transformed a North London Hotel into the 1970s Riviera Beach Club, as well as creating beautifully styled spaces across a wide range of unique venues we have access to. ",
			"Menu and packaging design, branding, art direction and food styling for content or events. Our approach aims to add layers of flavour for all the senses. ",
			"<i>We also run our own events, creative projects and supper clubs. Keep your eyes peeled via <a href='https://www.instagram.com/getroomservice/' target='_blank'>Instagram</a></i>"
		],
		"folder": "projects",
		"lockup": {
			"lockup_1": "projects_lockup_portrait_01.jpg",
			"lockup_2": "projects_lockup_landscape_01.jpg",
			"lockup_3": "projects_lockup_square_01.jpg",
			"text_img": "masthead_text_projects.png"
		},
		"loadArray": [
			"projects/projects_lockup_portrait_01.jpg",
			"projects/projects_lockup_landscape_01.jpg",
			"projects/projects_lockup_square_01.jpg",
			"projects/masthead_text_projects.png"
		]
	},
	"takeaway": {
		"title": "HOME EDITION",
		"subtitle": "REFINED GOOD TIMES FOOD TO FEAST AT HOME.<br/><br/>HOT TAKEAWAYS AND D.I.Y. <br class='break-small' />FOOD KITS<br/><br/>REGULARLY CHANGING MENUS. DELIVERY OR COLLECTION.",
		"body_tdw": [
			"There are no romantic getaways this year so let us bring the dirty weekend to you. <br/><br/>Expect luxury hotel classics with a loved up flavour. <strong>Heads, Hearts & Tails</strong> have you fully covered on the drinks front, plus complete the love-fix with flowers from <strong>Floral Cacophony</strong>."
		],
		"body": [
			"We’ve lockdown-proofed ourselves for 2021, bringing our slice of food indulgence to<br/>your dining tables, sofas and beds. <br class='break-small' />Proper Room Service.",
			"<span class='body-title'>WHAT WE OFFER:</span><br/><br/>- Regularly changing menus of ready to go feasts for delivery or collection.<br/><br/>- DIY meal kits and food boxes to prep at home.<br/><br/>- Bespoke requests. Try us!",
			"<span class='body-title'>COLLECTION & DELIVERY:</span><br/><br/>We are now delivering London-wide. Please get in touch if you need more info.<br/><br/>If you are collecting, please be sure to select a time slot at check out.<br/><br/>Collection is from our kitchen unit in the heart of Barnes:<br/><br/><strong>Unit 1, The Mews, 46-52 Church Rd, SW13 0DQ</strong><br/>(just on Bracken Gardens above the mechanics)."
		],
		"menu_button": "THIS WEEK’S MENU",
		"menu_link": "http://getroomservice.co/menus/20210116_menu.pdf",
		"second_menu_button": "NYE VEGGIE MENU",
		"second_menu_link": "http://getroomservice.co/menus/20201231_veggie.pdf",
		"order_button_old": "ORDER NOW",
		"order_button": "MENUS & ORDERING",
		"shopify_link": "https://getroomservice.myshopify.com/",
		"order_email": "hello@getroomservice.co",
		"folder": "food",
		"lockup": {
			"lockup_1": "lockup_portrait_01.jpg",
			"lockup_2": "lockup_landscape_01.jpg",
			"lockup_3": "logo.png",
			"text_img": "masthead_text2_takeaway.png"
		},
		"old": [
			"<span class='body-title'>HOW TO ORDER</span>",
			"",
			"Email <a href='mailto:hello@getroomservice.co'>hello@getroomservice.co</a> by <strong>Midday on Thursday</strong>.<br/><br/>In your email state: order quantities, side orders (don’t forget to specify quantities of each side portion), collection/delivery time and day, name, address and contact telephone number.<br/><br/>We will reply with confirmations and payment details.<br/><br/>If you have any allergies or dietary preferences, please let us know.",
			"*"
		]
	},
	"loadArray": [
		"home/home_lockup_portrait_01.jpg",
		"home/home_lockup_landscape_01.jpg",
		"home/home_lockup_square_01.jpg",
		"home/masthead_text.png",
		"home/food_home_landscape_01.jpg",
		"home/projects_home_landscape_01.jpg",
		"food/food_lockup_portrait_01.jpg",
		"food/food_lockup_landscape_01.jpg",
		"food/food_lockup_square_01.jpg",
		"food/masthead_text_food.png",
		"projects/projects_lockup_portrait_01.jpg",
		"projects/projects_lockup_landscape_01.jpg",
		"projects/projects_lockup_square_01.jpg",
		"projects/masthead_text_projects.png"
	],
	"about": {
		"title": "ABOUT",
		"subtitle": "A LONDON-BASED CATERING AND DESIGN COLLECTIVE <br class='break-large' />PRODUCING BESPOKE FOOD, EXPERIENCES AND CONTENT FOR A WIDE <br class='break-large' />SPECTRUM OF CLIENTS LOOKING FOR SOMETHING DIFFERENT",
		"body": [
			"Room Service launched with the ‘Club Sandwich Luxe’ pop-up and Shoreditch kitchen residency in 2015. Although the food and offering has evolved, the indulgent, shameless excess those towering club sandwiches represent set the template that runs through everything we do.",
			"Massively inspired by the diverse food scene in our native city (London) we get kicks from across the board; contemporary fine dining to fast food, global street food to British classics, the good life to the downright dirty. We champion food that is social and seasonal, with a laidback indulgence. In essence, we make food to make your party.",
			"Working with a stellar group of private clients, brands and companies, we have created everything from intimate dining experiences on private islands and festival food for 500 in fields, to social content and small bites for brand experiences.",
			"Every job, whatever the size, is treated with the same custom indulgence, care and excitement. Our team and network have backgrounds in private catering, restaurants, bars, street food, event production, styling, design and marketing. This means we can deliver way more than just food on a plate."
		]
	},
	"takeaway_popup": {
		"active": false,
		"hasAppeared": false,
		"showMe": false,
		"showon": [
			"takeaway"
		],
		"title": "",
		"body": [
			"WE ARE HAVING A COUPLE OF WEEKS OFF <br/>OVER CHRISTMAS.",
			"THANK YOU TO EVERYONE WHO’S ORDERED <br/>OVER THE LAST FEW WEEKS. WE’VE REALLY <br/>APPRECIATED THE SUPPORT.",
			"WE ARE FLIRTING WITH THE IDEA OF DOING A SPECIAL NEW YEAR’S EVE MENU. KEEP YOUR EYES PEELED FOR MORE INFO.",
			"FOLLOW US ON INSTAGRAM FOR ALL THE <br/>LATEST NEWS AND UPDATES: <a href='https://www.instagram.com/getroomservice/' target='_blank'>@GETROOMSERVICE</a>",
			"MERRY CHRISTMAS!"
		],
		"popup_button_active": false,
		"popup_button": "READ MORE",
		"popup_route": "takeaway",
		"popup_image_logo": "/takeaway/logo.png",
		"popup_image_title": "/takeaway/masthead_text2_takeaway.png",
		"popup_image_main_desktop": "/takeaway/lockup_portrait_01.jpg",
		"popup_image_main_mobile": "/takeaway/lockup_landscape_01.jpg"
	},
	"popup": {
		"active": false,
		"hasAppeared": false,
		"showMe": false,
		"showon": [
			"homeedition"
		],
		"title": "",
		"body": [
			"We’ve lockdown-proofed ourselves for 2021, bringing our slice of food indulgence to<br/>your dining tables, sofas and beds. Proper Room Service."
		],
		"popup_button": "READ MORE",
		"popup_route": "homeedition",
		"popup_image_logo": "/takeaway/logo.png",
		"popup_image_title": "/takeaway/masthead_text2_takeaway.png",
		"popup_image_main_desktop": "/takeaway/lockup_portrait_01.jpg",
		"popup_image_main_mobile": "/takeaway/lockup_landscape_01.jpg"
	},
	"slideshow": {
		"home_array": [
			{
				"title": "Spotify<br/>Wimborne House",
				"img1": "spotify2_landscape_01.jpg",
				"img2": "spotify2_portrait_01.jpg",
				"img3": "spotify2_square_01.jpg",
				"t": 1
			},
			{
				"title": "Chassay & Co<br/>Shoreditch Treehouse",
				"img1": "chassay_landscape_02.jpg",
				"img2": "chassay_landscape_01.jpg",
				"img3": "chassay_portrait_01.jpg",
				"t": 4
			},
			{
				"title": "Spotify<br/>Vinyl Factory",
				"img1": "spotify1_landscape_03.jpg",
				"img2": "spotify1_landscape_02.jpg",
				"img3": "spotify1_landscape_01.jpg",
				"t": 2
			},
			{
				"title": "Buzzfeed<br/>33 Fitzroy Square",
				"img1": "buzzfeed_landscape_01.jpg",
				"img2": "buzzfeed_landscape_02.jpg",
				"img3": "buzzfeed_landscape_03.jpg",
				"t": 3
			},
			{
				"title": "Proper<br/>Social Campaign",
				"img1": "proper_portrait_01.jpg",
				"img2": "proper_portrait_02.gif",
				"img3": "proper_square_01.jpg",
				"t": 6
			},
			{
				"title": "Curzon Cinemas",
				"img1": "curzon_square_01.jpg",
				"img2": "curzon_landscape_02.jpg",
				"img3": "curzon_portrait_01.jpg",
				"t": 5
			},
			{
				"title": "Club Sandwich Luxe",
				"img1": "sandwich_landscape_01.jpg",
				"img2": "sandwich_portrait_01.jpg",
				"img3": "sandwich_square_01.jpg",
				"t": 1
			},
			{
				"title": "Open Table<br/>Kings Cross",
				"img1": "opentable_landscape_02.jpg",
				"img2": "opentable_landscape_01.jpg",
				"img3": "opentable_landscape_03.jpg",
				"t": 2
			}
		],
		"food_array": [
			{
				"title": "",
				"img1": "food_carousel_01_01.jpg",
				"img2": "food_carousel_01_02.jpg",
				"img3": "food_carousel_01_03.jpg",
				"t": 7
			},
			{
				"title": "",
				"img1": "food_carousel_02_01.jpg",
				"img2": "food_carousel_02_02.jpg",
				"img3": "food_carousel_02_03.jpg",
				"t": 8
			},
			{
				"title": "",
				"img1": "food_carousel_03_02.jpg",
				"img2": "food_carousel_03_01.jpg",
				"img3": "food_carousel_03_03.jpg",
				"t": 9
			},
			{
				"title": "",
				"img1": "food_carousel_04_01.jpg",
				"img2": "food_carousel_04_02.jpg",
				"img3": "food_carousel_04_03.jpg",
				"t": 10
			},
			{
				"title": "",
				"img1": "food_carousel_05_01.jpg",
				"img2": "food_carousel_05_03.jpg",
				"img3": "food_carousel_05_02.jpg",
				"t": 11
			}
		],
		"projects_array": [
			{
				"title": "",
				"img1": "projects_carousel_01_01.jpg",
				"img2": "projects_carousel_01_02.jpg",
				"img3": "projects_carousel_01_03.jpg",
				"t": 12
			},
			{
				"title": "",
				"img1": "projects_carousel_02_01.jpg",
				"img2": "projects_carousel_02_02.jpg",
				"img3": "projects_carousel_02_03.jpg",
				"t": 13
			},
			{
				"title": "",
				"img1": "projects_carousel_03_01.jpg",
				"img2": "projects_carousel_03_02.jpg",
				"img3": "projects_carousel_03_03.jpg",
				"t": 14
			},
			{
				"title": "",
				"img1": "projects_carousel_04_01.jpg",
				"img2": "projects_carousel_04_03.jpg",
				"img3": "projects_carousel_04_02.jpg",
				"t": 15
			},
			{
				"title": "",
				"img1": "projects_carousel_05_01.jpg",
				"img2": "projects_carousel_05_03.jpg",
				"img3": "projects_carousel_05_02.jpg",
				"t": 16
			}
		]
	},
	"ticker": {
		"home": [
			{
				"entry": "Dinners & Banquets"
			},
			{
				"entry": "Canapés"
			},
			{
				"entry": "Food Boxes"
			},
			{
				"entry": "BBQ’s"
			},
			{
				"entry": "Small Plates"
			},
			{
				"entry": "Street Food"
			},
			{
				"entry": "Fast Food"
			},
			{
				"entry": "Crew & Shoot Catering"
			},
			{
				"entry": "Hampers"
			},
			{
				"entry": "Artist Riders"
			},
			{
				"entry": "Corporate Lunches"
			},
			{
				"entry": "Private Chef Service"
			},
			{
				"entry": "Themed Food & Feasts"
			},
			{
				"entry": "Brand Experiences"
			},
			{
				"entry": "Supper Clubs"
			},
			{
				"entry": "Menu Design & Consultancy"
			},
			{
				"entry": "Event Production"
			},
			{
				"entry": "Food Styling"
			},
			{
				"entry": "Brand Content"
			},
			{
				"entry": "Event Bars"
			},
			{
				"entry": "Creative Direction"
			},
			{
				"entry": "Event Styling"
			},
			{
				"entry": "‘White Label’ Event Food"
			}
		],
		"food": [
			{
				"entry": "Dinners & Banquets"
			},
			{
				"entry": "Canapés"
			},
			{
				"entry": "Food Boxes"
			},
			{
				"entry": "BBQ’s"
			},
			{
				"entry": "Small Plates"
			},
			{
				"entry": "Street Food"
			},
			{
				"entry": "Fast Food"
			},
			{
				"entry": "Crew & Shoot Catering"
			},
			{
				"entry": "Hampers"
			},
			{
				"entry": "Artist Riders"
			},
			{
				"entry": "Corporate Lunches"
			},
			{
				"entry": "Private Chef Service"
			},
			{
				"entry": "Themed Food & Feasts"
			}
		],
		"projects": [
			{
				"entry": "Brand Experiences"
			},
			{
				"entry": "Supper Clubs"
			},
			{
				"entry": "Menu Design & Consultancy"
			},
			{
				"entry": "Event Production"
			},
			{
				"entry": "Food Styling"
			},
			{
				"entry": "Brand Content"
			},
			{
				"entry": "Event Bars"
			},
			{
				"entry": "Creative Direction"
			},
			{
				"entry": "Event Styling"
			},
			{
				"entry": "‘White Label’ Event Food"
			}
		]
	},
	"clients": {
		"title": "WHO WE'VE WORKED WITH",
		"array": [
			{
				"logo": "nike.svg"
			},
			{
				"logo": "curzon.svg"
			},
			{
				"logo": "sonos.svg"
			},
			{
				"logo": "warner.svg"
			},
			{
				"logo": "converse.svg"
			},
			{
				"logo": "airbnb.svg"
			},
			{
				"logo": "buzzfeed.svg"
			},
			{
				"logo": "coach.svg"
			},
			{
				"logo": "nbcuniversal.svg"
			},
			{
				"logo": "spotify.svg"
			},
			{
				"logo": "mcsaatchi.svg"
			},
			{
				"logo": "veuveclicquot.svg"
			},
			{
				"logo": "amplify.svg"
			},
			{
				"logo": "opentable.svg"
			},
			{
				"logo": "ovalspace.svg"
			},
			{
				"logo": "proper.svg"
			},
			{
				"logo": "chivas.svg"
			},
			{
				"logo": "goodstuff.svg"
			}
		]
	},
	"footer": {
		"array": [
			{
				"img": "footer_01.jpg"
			},
			{
				"img": "footer_02.jpg"
			},
			{
				"img": "footer_03.jpg"
			},
			{
				"img": "footer_04.jpg"
			},
			{
				"img": "footer_05.jpg"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./content.json
// module id = 2
// module chunks = 2